import React from "react"
import {
  Box, Grid, GridItem, Text,
} from "@chakra-ui/react"
import EditorSection from "components/Builder/components/EditorSection"
import { Control, useController, UseFormSetValue } from "react-hook-form"
import SwitchField from "components/ReactHookForm/SwitchField"
import Select from "components/ReactHookForm/Select"
import { Form } from "sharedTypes"
import Field from "../../../RegistrationFields/Field"
import Fieldset from "../../../RegistrationFields/Fieldset"
import formatPlusOneFields from "../../../RegistrationFields/formatPlusOneFields"

type Props = {
  control: Control<any>
  form: Form
  setValue: UseFormSetValue<any>
}

const ManagePlusOnes = ({ control, form, setValue }: Props) => {
  const { field: { value: plusOnesEnabled } } = useController({ name: "plusOnesEnabled", control })
  const plusOneFields = formatPlusOneFields(form)

  return (
    <EditorSection>
      <Box mb={4}>
        <Grid
          templateColumns="repeat(5, 1fr)"
          rowGap={2}
          columnGap={3}
        >
          <GridItem colSpan={4}>
            <Text fontSize="lg" fontWeight="bold">Allow Guests to Manage Their Plus-Ones</Text>
          </GridItem>
          <GridItem colSpan={1} justifySelf="end">
            <SwitchField size="lg" control={control} name="plusOnesEnabled" />
          </GridItem>
          <GridItem colSpan={5}>
            <Text>
              When enabled, guests can add plus-ones while submitting the RSVP form. Guests with
              existing plus-ones can also review and update them.
            </Text>
          </GridItem>
          {plusOnesEnabled && (
            <>
              <GridItem colSpan={4}>
                <Text fontWeight="semibold">Maximum plus-ones allowed for this form</Text>
              </GridItem>
              <GridItem colSpan={1}>
                <Select
                  control={control}
                  name="maxPlusOnes"
                  options={[...Array(10)].map((_number, index) => {
                    const count = index + 1

                    return (
                      { label: count.toString(), value: count }
                    )
                  })}
                />
              </GridItem>
              {form.spotsLeft !== null && (
                <GridItem colSpan={5}>
                  <Text fontSize="sm" color="gray.600">
                    Guests can&apos;t add more plus-ones than the event has spots left.
                  </Text>
                </GridItem>
              )}
            </>
          )}
        </Grid>
      </Box>
      {plusOnesEnabled && (
        <>
          <Fieldset title="Plus-One Settings">
            <>
              {plusOneFields.map(({
                name, fieldName, requiredLocked, hideRequired,
              }) => (
                <Field
                  key={fieldName}
                  label={name}
                  name={fieldName}
                  control={control}
                  requiredLocked={requiredLocked}
                  hideRequired={hideRequired}
                  setValue={setValue}
                />
              ))}
            </>
          </Fieldset>
          <Text px={6} pb={4} fontSize="sm" color="gray.600">
            If both Name and Email are disabled, guests will only select the number of plus-ones,
            and Diobox will automatically create placeholder plus-one records.
          </Text>
        </>
      )}
    </EditorSection>
  )
}

export default ManagePlusOnes
